<div class="ahf-list-menu sign-in-bar amwayBtnlogin"
  data-login="yes"
  (click)="toggleUserModal()">
  <div class="amway-user ">
    <app-image-loader [class]="'amway-user-img'"
      [src]="(image$ | async)?.url || 'assets/image/header/user-avatar.png'"></app-image-loader>
  </div>
  <div class="sib-name ">{{firstName}}</div>
</div>
<app-header-user-info-sidebar [open]="viewModal"
  [fullName]="fullName"
  (closeUserModalEvent)="toggleUserModal()"></app-header-user-info-sidebar>
